import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

export const getTestimonialListSaga = createAction(
  "GET_TESTIMONIAL",
  ({ payload, params }: SagaActionParams<Type.TestimonialDto[]>) => ({
    payload,
    url: "/api/admin/testimonials" + (params ? params : ""),
  })
);
export const getTestimonialDetailsSaga = createAction(
  "GET_TESTIMONIAL_DETAILS",
  ({ payload, id }: SagaActionParams<Type.TestimonialDetailDto>) => ({
    payload,
    url: "/api/admin/testimonials/" + id,
  })
);
export const createTestimonialSaga = createAction(
  "CREATE_TESTIMONIAL",
  ({ payload, body }: SagaActionParams<Type.TestimonialDto>) => ({
    payload,
    url: "/api/admin/testimonials",
    body,
  })
);
export const updateTestimonialSaga = createAction(
  "UPDATE_TESTIMONIAL",
  ({ payload, id, body }: SagaActionParams<Type.TestimonialDto>) => ({
    payload,
    url: "/api/admin/testimonials/" + id,
    body,
  })
);
export const deleteTestimonialSaga = createAction(
  "DELETE_TESTIMONIAL",
  ({ payload, id }: SagaActionParams<Type.TestimonialDto>) => ({
    payload,
    url: "/api/admin/testimonials/" + id,
  })
);

const testimonialsSaga = [
  takeLatest<any>(
    getTestimonialListSaga.toString(),
    (payload: SagaGenericParams<Type.TestimonialDto[]>) =>
      getSaga<Type.TestimonialDto[]>(payload)
  ),
  takeLatest<any>(
    getTestimonialDetailsSaga.toString(),
    (payload: SagaGenericParams<Type.TestimonialDetailDto>) =>
      getSaga<Type.TestimonialDetailDto>(payload)
  ),
  takeLatest<any>(
    createTestimonialSaga.toString(),
    (payload: SagaGenericParams<Type.TestimonialDto>) =>
      postSaga<Type.TestimonialDto>(payload)
  ),
  takeLatest<any>(
    updateTestimonialSaga.toString(),
    (payload: SagaGenericParams<Type.TestimonialDto>) =>
      putSaga<Type.TestimonialDto>(payload)
  ),
  takeLatest<any>(
    deleteTestimonialSaga.toString(),
    (payload: SagaGenericParams<any>) =>
      deleteSaga<Type.TestimonialDto>(payload)
  ),
];

export default testimonialsSaga;
